import React from 'react'
import Header from './Header'
import ProductPageFooter from './ProductPageFooter'
import DividoBody from './DividoBody'

const DividoProject = () => {
  return (
    <>
     <Header/>
     <DividoBody/>
     <ProductPageFooter/>
    </>
  )
}

export default DividoProject